<template>
  <div class="health_main">
      <card></card>
  </div>
</template>

<script>
import card from "./components/card_face";
export default {
  components: {
    card,
  },
};
</script>

<style lang="scss" scoped>
.health_main{
    height: 100vh;
    width: 100vw;
}
</style>